import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { ItemDisplay, LeverageCard, LeverageCardRow } from './leverageComponents';
import { SuggestedLeverageCardProps } from '../leverageStep';
import { LTC_CATCHUP_PERCENTAGE } from '../../../utils/utils';

export const GroundUpSuggestedLeverageCard = ({
  suggestedLoanQuote,
  quoteTypeStore,
}: SuggestedLeverageCardProps) => {
  const {
    initialAdvance = 0,
    constructionHoldback = 0,
    totalPurchasePrice = 0,
    totalProposedConstructionBudget = 0,
    loanToCost = 0,
    costBasis = 0,
    totalLoanAmount = 0,
    totalAfterRepairValue = 0,
    afterRepairLtv = 0,
    calculatedLtfc = 0,
    ltcCatchupDraw = false,
    ltcCatchupDrawAmount = 0,
    ltcCatchupDrawAmountPercentage = 0,
  } = suggestedLoanQuote;

  const constructionReserve =
    totalProposedConstructionBudget > 0
      ? (constructionHoldback / totalProposedConstructionBudget) * 100
      : 0;

  const purchasePriceLabel = quoteTypeStore.isMidConstructionRefinance()
    ? 'Cost Spent to Date'
    : 'Purchase Price';

  return (
    <LeverageCard
      title="Suggested Insta-Quote"
      subtitle="Calculated during loan submission. For reference only."
      disabled={false}
      instaQuote={true}
      LeverageMatrixCard={null}
      quoteTypeStore={null}
      disabledWarning={false}
    >
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Initial Loan Amount"
            value={formatCurrency(initialAdvance)}
          />
        }
        divisor={
          <ItemDisplay
            label={purchasePriceLabel}
            value={formatCurrency(totalPurchasePrice)}
          />
        }
        result={
          <ItemDisplay
            label="Loan to Cost"
            value={formatPercentage(loanToCost)}
          />
        }
      />
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Construction Holdback"
            value={formatCurrency(constructionHoldback)}
          />
        }
        divisor={
          <ItemDisplay
            label="Proposed Construction Budget"
            value={formatCurrency(totalProposedConstructionBudget)}
          />
        }
        result={
          <ItemDisplay
            label="Construction Reserve"
            value={formatPercentage(constructionReserve)}
          />
        }
      />
      {ltcCatchupDraw && (
        <LeverageCardRow
          dividend={
            <ItemDisplay
              label="LTC Catchup Draw Amount"
              value={formatCurrency(ltcCatchupDrawAmount)}
            />
          }
          divisor={
            <ItemDisplay
              label="Purchase Price"
              value={formatCurrency(totalPurchasePrice)}
            />
          }
          result={
            <ItemDisplay
              label="LTC Catchup Draw"
              value={formatPercentage(ltcCatchupDrawAmountPercentage || LTC_CATCHUP_PERCENTAGE)}
            />
          }
        />
      )}
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Total Loan Amount"
            value={formatCurrency(totalLoanAmount)}
          />
        }
        divisor={
          <ItemDisplay
            label="Total Cost"
            value={formatCurrency(costBasis)}
          />
        }
        result={
          <ItemDisplay
            label="Total Loan To Cost"
            value={formatPercentage(calculatedLtfc)}
          />
        }
      />
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Total Loan Amount"
            value={formatCurrency(totalLoanAmount)}
          />
        }
        divisor={
          <ItemDisplay
            label="After Repair Value"
            value={formatCurrency(totalAfterRepairValue)}
          />
        }
        result={
          <ItemDisplay
            label="ARLTV"
            value={formatPercentage(afterRepairLtv)}
          />
        }
      />
    </LeverageCard>
  );
};
